import { render, staticRenderFns } from "./score3.vue?vue&type=template&id=31739030&scoped=true"
import script from "./score3.vue?vue&type=script&lang=js"
export * from "./score3.vue?vue&type=script&lang=js"
import style0 from "./score3.vue?vue&type=style&index=0&id=31739030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31739030",
  null
  
)

export default component.exports